export { ERC20ABI } from "./erc20ABI";
export { default as ERC20_BYTES32_ABI } from "./erc20_bytes32.json";
